import { IPolicyAuth } from '@app/models';
import _ from 'lodash';

export const doesPolicyRequireMFA = (authPolicy: IPolicyAuth): boolean => {
    if (authPolicy['@odata.type'] === '#Kaseya.AuthAnvil.Models.EnhancedAuthenticationPolicy') {
        if (authPolicy.Configuration) {
            let configuration: any = JSON.parse(authPolicy.Configuration);
            if (configuration) {
                let returnVal = false;
                configuration.forEach((config: any) => {
                    let actions = config.actions;
                    if (actions && actions.length) {
                        let requiredMethods = _.find(actions, { Type: 'RequiredMethods' });
                        if (requiredMethods && requiredMethods.Configuration && requiredMethods.Configuration.RequiresMfa) {
                            returnVal = true;
                        }
                    }
                });
                if (returnVal) {
                    return true;
                }
            }
        }
    }
    return false;
};

export const doesPolicySetPasswordFalse = (authPolicy: IPolicyAuth): boolean => {
    // must be of type EnhancedAuthenticationPolicy
    if (authPolicy['@odata.type'] === '#Kaseya.AuthAnvil.Models.EnhancedAuthenticationPolicy') {
        let requiresPasswordEntries: any[] = [];

        if (authPolicy.Configuration) {
            let configuration: any = JSON.parse(authPolicy.Configuration);
            if (configuration) {
                configuration.forEach((config: any) => {
                    let actions = config.actions;
                    if (actions && actions.length) {
                        let requiredMethods = _.find(actions, { Type: 'AllowedMethods' });

                        // capture requires password entry
                        if (requiredMethods && requiredMethods.Configuration && (requiredMethods.Configuration.RequiresPassword !== undefined)) {
                            requiresPasswordEntries.push(requiredMethods.Configuration.RequiresPassword);
                        }
                    }
                });

                // must have at least one RequiresPassword entry
                if (requiresPasswordEntries.length > 0) {
                    // all the entries must be set to false
                    if (requiresPasswordEntries.reduce((accumulator, currentEntry) => { return accumulator || currentEntry; }) === false) {
                        return true;
                    }
                }
            }
        }
    }
    return false;
};
